module.exports = __webpack_public_path__ + "static/smith-lovelace-read-bb062c810b52c4ef00c774018a803c86.jpg";